export default "__VITE_ASSET__BkRBIZIY__"